import { render, staticRenderFns } from "./multiselect_permission.vue?vue&type=template&id=380e0f96&scoped=true&"
import script from "./multiselect_permission.vue?vue&type=script&lang=js&"
export * from "./multiselect_permission.vue?vue&type=script&lang=js&"
import style0 from "./multiselect_permission.vue?vue&type=style&index=0&id=380e0f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e0f96",
  null
  
)

export default component.exports